module.exports = __webpack_public_path__ + "static/media/ie.89b234d7.ico";